import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { getCardapioRedirect } from '../services/cardapioAPI';

const CardapioRedirectHandler: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();
  const [error, setError] = useState<string>('');

  useEffect(() => {
    const handleRedirect = async () => {
      if (!slug) {
        setError('Cardápio não encontrado');
        return;
      }

      try {
        const data = await getCardapioRedirect(slug);

        if (data.success && data.link_id) {
          navigate(`/cardapio-menu/${data.link_id}`, { replace: true });
        } else {
          setError(data.error || 'Cardápio não encontrado');
        }
      } catch (err: any) {
        console.error('Erro ao acessar cardapio:', err);
        setError(err.response?.data?.error || 'Erro ao acessar cardapio');
      }
    };

    handleRedirect();
  }, [slug, navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="text-center max-w-md">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <AlertCircle className="w-8 h-8 text-red-600" />
          </div>
          <h1 className="text-xl font-bold text-gray-900 mb-2">Erro</h1>
          <p className="text-gray-600">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin w-12 h-12 border-4 border-primary-600 border-t-transparent rounded-full mx-auto mb-4"></div>
        <p className="text-gray-600">Carregando cardápio...</p>
      </div>
    </div>
  );
};

export default CardapioRedirectHandler;
